"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_toastify_1 = require("react-toastify");
const ecommerce_1 = require("../../api/ecommerce");
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const translation_1 = require("../../common/js/helper/translation");
const configuration_1 = __importDefault(require("../apis/configuration/shop/configuration"));
class DeleteAddressConfirmModal extends react_1.default.Component {
    isLoading = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            isLoading: mobx_1.observable,
        });
    }
    render() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "modal-header znd-modal__header" },
                react_1.default.createElement("h3", { className: "znd-modal__title" }, (0, translation_1.t)('user.profile.addresses.delete_address.title')),
                react_1.default.createElement("div", { className: "znd-modal__close", onClick: this.props.onCancel },
                    react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.close }))),
            react_1.default.createElement("div", { className: "modal-body znd-modal__body" },
                react_1.default.createElement("div", { className: "b-4" }, (0, translation_1.t)('user.profile.addresses.delete_address.confirm_modal.text'))),
            react_1.default.createElement("div", { className: "modal-footer znd-modal__footer" },
                react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.secondary, text: (0, translation_1.t)('message_modal.cancel'), onClick: () => {
                        this.props.onCancel();
                    } }),
                react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('message_modal.apply'), loading: this.isLoading, disabled: this.isLoading, onClick: () => {
                        this.isLoading = true;
                        const api = new ecommerce_1.ChangeRequestApi(configuration_1.default);
                        api.sendChangeRequest({
                            changeRequest: {
                                topic: ecommerce_1.ChangeRequestTopicEnum.Address,
                                object: ecommerce_1.ChangeRequestObjectEnum.DeleteAddress,
                                data: {
                                    externalId: this.props.externalId,
                                },
                            },
                        })
                            .then(() => {
                            react_toastify_1.toast.success((0, translation_1.t)('change_request_modal.send_success', {
                                object: ecommerce_1.ChangeRequestObjectEnum.DeleteAddress,
                            }));
                            this.props.onDone();
                        })
                            .catch(() => {
                            react_toastify_1.toast.error((0, translation_1.t)('change_request_modal.send_error', {
                                object: ecommerce_1.ChangeRequestObjectEnum.DeleteAddress,
                            }));
                        })
                            .finally(() => {
                            this.isLoading = false;
                        });
                    } }))));
    }
}
exports.default = (0, mobx_react_1.observer)(DeleteAddressConfirmModal);
